module.exports = "https://static.wmbcdn.com/uniweb/images/530e64595735945d47f78aa317b85f8d.svg";